import Service from "../Service";

const resource = "FrzPackingWorkStationRoles/";

export default {
    save(prd, requestID) {
        return Service.post(resource + "save", prd, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    listDetailRol(parameters, requestID) {
        return Service.post(resource + "listDetailRol", parameters, {
            params: { requestID: requestID },
        });
    },    
   
   
}; 